import { Fragment, useRef } from 'react'
import { NavLink } from 'react-router'
import { Mtds, useMtdsAppSticky } from 'prove-common'
import { adminNavigation } from '../../navigation'

export const SideBarLayout = () => {
  const stickyRef = useRef<HTMLElement>(null)
  useMtdsAppSticky(stickyRef)

  return (
    <>
      <Mtds.App.Toggle id='mtds-app-toggle' />
      <Mtds.App.Sidebar aria-label='Hovedmeny'>
        <Mtds.App.Sticky as={Mtds.Prose} ref={stickyRef}>
          {adminNavigation.map((group, index) => (
            <Fragment key={group.label}>
              {index > 0 && <Mtds.Divider />}
              {group.items.length > 1 && (
                <Mtds.Heading as='h2' data-size='2xs' data-app-expanded='true'>
                  {group.label}
                </Mtds.Heading>
              )}
              <menu>
                {group.items.map(({ to, label, icon: Icon }) => (
                  <li key={to}>
                    <Mtds.Button
                      as={NavLink}
                      to={to}
                      data-tooltip={label}
                      aria-label={label}
                    >
                      <Icon aria-hidden />
                    </Mtds.Button>
                  </li>
                ))}
              </menu>
            </Fragment>
          ))}
        </Mtds.App.Sticky>
      </Mtds.App.Sidebar>
    </>
  )
}
